import { cn } from '@/lib/utils';
import { formatTime } from '@/lib/utils';
import { getTierColor, getTierLabel } from '@/lib/decay';

interface TierIndicatorProps {
  tierIndex: number | null;
  discountPercent: number;
  secondsUntilDrop: number | null;
}

export function TierIndicator({
  tierIndex,
  discountPercent,
  secondsUntilDrop,
}: TierIndicatorProps) {
  const color = getTierColor(tierIndex);
  const label = getTierLabel(tierIndex);
  const isExpired = tierIndex === null;

  return (
    <div className="inline-flex items-center gap-3">
      <span
        className={cn(
          'h-3 w-3 rounded-full',
          !isExpired && 'animate-pulse',
        )}
        style={{ backgroundColor: color }}
      />
      <div className="flex flex-col">
        <div className="flex items-baseline gap-2">
          <span className="text-sm font-semibold text-white">{label}</span>
          <span className="text-sm font-bold text-white">
            {discountPercent}% off
          </span>
        </div>
        {secondsUntilDrop !== null && (
          <span className="text-xs tabular-nums text-gray-400">
            Next tier in {formatTime(secondsUntilDrop)}
          </span>
        )}
      </div>
    </div>
  );
}
